module.exports = __webpack_public_path__ + "img/手机_web.a701d4af.png";